import styled from 'styled-components';

export const UniqueBabySec = styled.div`
  background-color: ${(props) => props.background};
  padding: 10px 0;
  margin: 80px 0 20px;
  position: relative;

  @media (max-width: 720px) {
    margin: 50px 0 20px;
  }
`;

export const WhiteCard = styled.div`
  border-radius: 8px;
  margin: 16px 10px;
`;

export const NameBox = styled.ul`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  padding: 10px 8px;
  column-gap: 3%;
`;

export const NameList = styled.li`
  border-radius: 4px;
  border: solid 0.8px rgba(94, 151, 145, 0.2);
  background-color: #fff;
  display: inline-block;
  padding: 8px 6px;
  margin: 8px 0px;
  font-size: clamp(12px, 2vw, 16px);
  font-weight: 500;
  color: hsl(0deg, 0%, 0%, 80%);
  width: max-content;
  transition: all 0.2s ease-in-out;
  display: flex;
  align-items: center;
  img,
  svg {
    height: clamp(18px, 2vw, 22px);
    width: clamp(18px, 2vw, 22px);
    margin-right: 4px;
  }
  &:hover {
    transform: scale(1.02);
    border: solid 0.8px hsl(0deg, 0%, 0%, 80%);

    @media (max-width: 720px) {
      transform: scale(1);
    }
  }
`;

export const UniqueName = styled.h6`
  font-size: 12px;
  font-weight: 500;
  padding: 16px 10px 0;
  text-transform: uppercase;
  color: rgb(0 0 0 / 37%);
`;

export const UniqueTitle = styled.h3`
  text-transform: uppercase;
  font-size: clamp(16px, 2vw, 18px);
  color: rgb(0 0 0 / 80%);
  font-weight: 700;
  letter-spacing: 1px;
  padding: 16px 0 8px;
  display: flex;
  align-items: center;
  @media (max-width: 720px) {
    padding: 16px 0 0;
  }
`;

export const UniqueTitleSpan = styled.span`
  padding-left: 6px;
`;

export const PinkSlant = styled.img`
  width: 100%;
  height: auto;
  position: absolute;
  top: 0;
  left: 0;
  transform: translateY(-100%);
`;
export const ViewButton = styled.div`
  padding: 16px 10px 0;
  width: 70%;
  margin: auto;
  @media (max-width: 720px) {
    width: 100%;
  }
`;
